import { Meeting, Race, User } from '@api/types';
import { RaceGait, adaptRaceInformations } from '@components/Race/logic/adapter/raceInformations';
import { adaptRaceStatus } from '@features/Meeting/logic/adapter/raceStatus';

import type {
  MeetingIdTagPayload,
  QuinteTagPayload,
  RaceTagPayload,
  UserTagPayload,
} from './SendTag';

const extractUserTagPayload = (user: User): UserTagPayload => ({ user_type: user.role });

const extractMeetingIdTagPayload = (
  officialMeetingNumber?: number | null
): MeetingIdTagPayload => ({
  bet_reunion_id: officialMeetingNumber ? `R${officialMeetingNumber}` : '',
});

const extractRaceBaseTagPayload = (race?: Race) => {
  if (!race) {
    return {
      bet_course_id: '',
      discipline: '',
    };
  }

  const raceInformations = adaptRaceInformations(race);

  return {
    bet_course_id: `C${race.raceNumber}`,
    discipline: raceInformations.gait === RaceGait.GALLOP ? 'galop' : 'trot',
  };
};

const extractRaceTagPayload = (race: Race | undefined): RaceTagPayload => {
  return {
    ...extractRaceBaseTagPayload(race),
    etat_course: race?.raceStatus ? adaptRaceStatus(race.raceStatus) : '',
  };
};

const extractQuinteTagPayload = ({
  race,
  meeting,
  user,
}: {
  race?: Race;
  meeting?: Meeting;
  user: User;
}): QuinteTagPayload => {
  return {
    ...extractUserTagPayload(user),
    ...extractMeetingIdTagPayload(meeting?.officialMeetingNumber),
    ...extractRaceBaseTagPayload(race),
  };
};

export {
  extractMeetingIdTagPayload,
  extractQuinteTagPayload,
  extractRaceTagPayload,
  extractUserTagPayload,
};
